module.exports = __webpack_public_path__ + "img/demo1.1f917c3c.jpg";